import { render, staticRenderFns } from "./DeleteAllTestButton.vue?vue&type=template&id=77eb56bb&scoped=true"
import script from "./DeleteAllTestButton.vue?vue&type=script&lang=ts"
export * from "./DeleteAllTestButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eb56bb",
  null
  
)

export default component.exports